import React, { Component } from 'react';
import { RouteComponentProps } from '@reach/router';
import ArcadesList from './list';

class ArcadeListWrapper extends Component<RouteComponentProps> {
    render() {
        return (
            <ArcadesList />
        );
    }
}

export default ArcadeListWrapper;
